import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';

export const DataGridColumn = memo(
  ({
    fieldName,
    valueExtractor = (item) => item[fieldName],
    renderColumn,
    dataItem,
    flex = 1,
  }) => {
    const { styles } = useStyle();
    return (
      <View style={[styles.headerItemContainer, { flex }]}>
        {renderColumn?.(dataItem, valueExtractor(dataItem))}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  headerItemContainer: {
    alignItems: 'flex-start',
    overflow: 'hidden',
  },
}));
